<div adaptToolbarContent>
    @if (selectedSurvey && !compareMode) {
        <button adaptButtonIcon="fal fa-fw fa-file-export"
                [adaptBlockingClick]="exportSurvey"
                data-test="export-data-button">Export to Excel</button>
        <button adaptButtonIcon="printBorderless"
                (click)="initialiseElementsForPrint()">Print</button>
    }
    @if (!isMobile && surveys.length > 1) {
        <button adaptButtonIcon="fal fa-fw fa-balance-scale"
                [ngClass]="compareButtonClass"
                (click)="compareClicked(!compareMode)"
                data-test="compare-survey-button">Compare</button>
    }
</div>

@if (surveys.length > 0) {
    <adapt-toolbar-title>
        @if (!compareMode) {
            <div [ngClass]="{ 'd-flex': !isMobile }">
                <h3 class="align-self-center">Analysing survey</h3>
                <adapt-survey-selection-box class="ms-2 align-self-center"
                                            [surveys]="surveys"
                                            [(survey)]="selectedSurvey"
                                            (surveyChange)="onPrimarySurveyChanged($event)"></adapt-survey-selection-box>
            </div>
        } @else {
            <div class="d-flex">
                <h3 class="align-self-center">Comparing</h3>
                <adapt-survey-selection-box class="ms-2 align-self-center"
                                            [surveys]="surveys"
                                            [(survey)]="selectedSurvey"
                                            (surveyChange)="onPrimarySurveyChanged($event)"
                                            data-test="compare-from-survey"></adapt-survey-selection-box>
                <h3 class="align-self-center ms-2">with</h3>
                <adapt-survey-selection-box class="ms-2 align-self-center"
                                            [surveys]="surveys"
                                            [(survey)]="selectedSurvey2"
                                            (surveyChange)="onSecondarySurveyChanged($event)"
                                            data-test="compare-to-survey"></adapt-survey-selection-box>
            </div>
        }
    </adapt-toolbar-title>
}

@if (surveys.length > 0) {
    <div [ngClass]="compareMode ? 'row' : ''">
        <adapt-analyse-survey #firstSurvey
                              [ngClass]="compareMode ? 'col-md-6' : ''"
                              [compareMode]="compareMode"
                              [(maxResponseCounts)]="maxResponses"
                              (categorySummaryHeights)="leftHeights = $event"
                              [otherCategorySummaryHeights]="rightHeights"
                              [currentSurvey]="selectedSurvey"
                              [forceInitialise]="forceInitialise"></adapt-analyse-survey>
        @if (compareMode) {
            <adapt-analyse-survey #secondSurvey
                                  class="col-md-6"
                                  [compareMode]="compareMode"
                                  [(maxResponseCounts)]="maxResponses"
                                  (categorySummaryHeights)="rightHeights = $event"
                                  [otherCategorySummaryHeights]="leftHeights"
                                  [currentSurvey]="selectedSurvey2"
                                  [forceInitialise]="forceInitialise"></adapt-analyse-survey>
        }
    </div>
}
<dx-load-panel class="dx-load-panel"
               [shadingColor]="'rgba(0,0,0,0.5)'"
               [position]="{ of: '#content' }"
               [visible]="printLoading$ | async"
               [showIndicator]="true"
               [showPane]="true"
               [message]="'Preparing page for printing…'"
               [shading]="true"
               [hideOnOutsideClick]="false"> </dx-load-panel>
